var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress-circle"},[_c('div',{staticClass:"progress-circle__outer",class:_vm.outerCircleClass,style:(_vm.outerCircleStyle)},[_c('div',{staticClass:"progress-circle__inner",class:_vm.innerCircleClass},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }